package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueDraftResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.ReviewVenueDraftCommand

class ReviewVenueDraftUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ReviewVenueDraftCommand, DomainResult<VenueDraftResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ReviewVenueDraftCommand): DomainResult<VenueDraftResponse> {
        return venuesRepository.reviewVenueDraft(
            venueId = command.venueId,
            approved = command.approved
        )
    }
}
